import React, { useState } from "react";
import team30 from "src/assets/img/team/30.webp";

import AIIMG from "src/assets/img/ai.gif";

import {
  Typography,
  Breadcrumb,
  Avatar,
  Row,
  Col,
  Divider,
  Card,
  Tabs,
} from "antd";
import {
  BellOutlined,
  LogoutOutlined,
  MailOutlined,
  SettingFilled,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import type { MenuProps, TabsProps } from "antd";
import { Menu } from "antd";
import { useNavigate } from "react-router-dom";

type MenuItem = Required<MenuProps>["items"][number];

const { Title } = Typography;

const MobileProfile: React.FC = () => {
  const navigate = useNavigate();

  const redirectTo = (to: string) => {
    navigate(to);
  };

  const items: MenuItem[] = [
    {
      key: "1",
      icon: <MailOutlined />,
      label: "Profile",
      onClick: () => navigate("/user/profile"),
    },
    {
      key: "2",
      icon: <BellOutlined />,
      label: "Notifications",
      onClick: () => navigate("/user/profile/notification_preferences"),
    },
    {
      key: "3",
      icon: <SettingOutlined />,
      label: "Settings",
      onClick: () => navigate("/user/profile/account_settings"),
    },
    {
      key: "4",
      icon: <LogoutOutlined />,
      label: "Log Out",
      onClick: () => {
        localStorage.clear();
        navigate("/");
      },
    },
  ];

  const tabs: TabsProps["items"] = [
    {
      key: "1",
      label: <>Quick Pick</>,
      children: (
        <>
          <Row
            gutter={[16, 5]}
            style={{ marginBottom: 16, textAlign: "center" }}
          >
            <Col span={12}>
              <Card
                variant="borderless"
                onClick={() => redirectTo("/user/profile")}
              >
                <span style={{ fontSize: "15px" }}>
                  <UserOutlined /> Profile
                </span>
              </Card>
            </Col>
            <Col span={12}>
              <Card
                variant="borderless"
                onClick={() =>
                  redirectTo("/user/profile/notification_preferences")
                }
              >
                <span style={{ fontSize: "15px" }}>
                  <BellOutlined /> Notifications
                </span>
              </Card>
            </Col>
            <Col span={12}>
              <Card
                variant="borderless"
                onClick={() => redirectTo("/user/profile/account_settings")}
              >
                <span style={{ fontSize: "15px" }}>
                  <SettingOutlined /> Settings
                </span>
              </Card>
            </Col>
            <Col span={12}>
              <Card
                variant="borderless"
                onClick={() => redirectTo("/user/profile/other_settings")}
              >
                <span style={{ fontSize: "15px" }}>
                  <SettingFilled /> Other Settings
                </span>
              </Card>
            </Col>
          </Row>
        </>
      ),
    },
  ];

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
      }}
    >
      {/* Breadcrumb */}
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>Pages</Breadcrumb.Item>
        <Breadcrumb.Item>User Profile</Breadcrumb.Item>
      </Breadcrumb>

      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={10} sm={10} style={{ textAlign: "left" }}>
          <Avatar
            style={{ width: "100px", height: "100px" }}
            size="large"
            src={localStorage.getItem("profile_image") ?? team30}
          />
        </Col>
        <Col xs={14} sm={14} style={{ textAlign: "left" }}>
          {/* Page Title */}
          <Title level={3}> {localStorage.getItem("role")}</Title>
          <span style={{ fontSize: "10px" }}>
            {" "}
            {localStorage.getItem("username")}
          </span>
          <br />
          <span style={{ fontSize: "10px" }}>
            {" "}
            {" Last Login: " + localStorage.getItem("last_logined")}
          </span>
        </Col>
      </Row>
      <Divider />
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "auto",
        }}
      >
        <img
          src={AIIMG}
          alt="ai"
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            width: 30,
            height: 30,
            zIndex: 10,
          }}
        />
        <Tabs defaultActiveKey="1" items={tabs} />
      </div>
      <Row>
        <Col xs={24} sm={24} style={{ textAlign: "left" }}>
          <Menu mode="inline" style={{ width: "100%" }} items={items} />
        </Col>
      </Row>
    </div>
  );
};

export default MobileProfile;
